/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Meja_OkInputs */

const en_tut_meja_ok = /** @type {(inputs: Tut_Meja_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your desk shows the **Privat · zona tenang 3 × 3** badge, and people passing through that zone neither hear you nor are heard.`)
};

const id_tut_meja_ok = /** @type {(inputs: Tut_Meja_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meja Anda menampilkan badge **Privat · zona tenang 3 × 3**, dan rekan yang melintas di zona itu tidak lagi mendengar atau terdengar.`)
};

/**
* | output |
* | --- |
* | "Your desk shows the **Privat · zona tenang 3 × 3** badge, and people passing through that zone neither hear you nor are heard." |
*
* @param {Tut_Meja_OkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_meja_ok = /** @type {((inputs?: Tut_Meja_OkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Meja_OkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_meja_ok(inputs)
	return en_tut_meja_ok(inputs)
});